module.exports = __webpack_public_path__ + "static/img/banner_solutions_hpc.e8a561c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_hpc.png
// module id = ndwF
// module chunks = 10